<template>
	<div class="mainWrapper po">
		<h1>Warehouse Product Transfer</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/warehouse/transfer/create">
					Create Product Transfer
				</router-link></b-button
			>

			<b-button type="is-info"
				><router-link to="/warehouse/transfer/import">
					CSV Import
				</router-link></b-button
			>

			<b-button type="is-info"
				><router-link to="/warehouse/transfer/export">
					Export Transfer
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchPrductTransfer" placeholder="Transfer Search" @keyup.native.enter="searchTransfer()"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="searchTransfer()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="transferList header">
				<div>TRANSFER CODE</div>
				<div>BRAND</div>
				<div>SHOP</div>
				<div>AUTHOR</div>
				<div>CREATED DATE</div>

				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="transferList">
				<div>{{ item.code }}</div>
				<div>{{ item.brand.name }}</div>
				<div>{{ item.shop.name }}</div>
				<div>
					{{ item.author.name }}
				</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="transferDetail(item._id)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrder',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchPrductTransfer: null
		}
	},

	mounted: async function() {
		if (this.$route.params.page == undefined) {
			this.page = 1
		}

		// Get all the PO
		var data = {
			limit: this.limit,
			populate: ['author', 'brand', 'shop']
		}

		const apiGetTransfer = await this.$api.getProductTransfer({ data })
		this.pageCount = Math.ceil(apiGetTransfer.data.total / this.limit)
		this.list = apiGetTransfer.data.list
	},

	methods: {
		piStatus: function(item) {
			if (item.disable) {
				return 'DISABLED'
			}

			return item.status ? 'OPEN' : 'CLOSED'
		},

		// When user entered search
		searchTransfer: async function() {
			// Calculate how many items to skip

			var data = {
				limit: this.limit,
				populate: ['author', 'brand', 'shop']
			}

			if (this.searchPrductTransfer) {
				data.code = this.searchPrductTransfer
			}

			const apiGetTransfer = await this.$api.getProductTransfer({ data })
			this.pageCount = apiGetTransfer.data.total / this.limit
			this.list = apiGetTransfer.data.list
		},

		// When user click on page number
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author', 'brand', 'shop']
			}

			if (this.searchPrductTransfer) {
				data.code = this.searchPrductTransfer
			}

			const apiGetTransfer = await this.$api.getProductTransfer({ data })
			this.pageCount = Math.ceil(apiGetTransfer.data.total / this.limit)
			this.list = apiGetTransfer.data.list
		},

		// Push to detail page
		transferDetail: function(id) {
			// this.$router.push("/po/detail/" + id);
			this.$router.push({ name: 'transferDetail', params: { id } })
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/WarehouseTransfer.css';
</style>
